import Hero from "../components/Hero"
import camsImg from "../assets/img/banners/cams.png" 
import TabsRender from "../components/Tabs"
import { useEffect } from "react"

export default function Contacto() {
    
    useEffect(() => {
        document.title = "ProMedic - Centros de Atención Médica"
    }, [])
    
    return (
        <>
            <Hero img={camsImg} position="relative"/>
            <div className="mt-[22vh] md:mt-[34%] mx-auto">
                <TabsRender />
            </div>
        </>
    )
}